<template>
  <div class="klickbox-edit-code" v-if="step.kind === 'welcome'">
    <div>
      <div class="kp-modular-row clearfix">
        <label class="kp-modular-label label__checkbox">{{ $t('edit.canvas.welcome_buttons') }}</label>
        <select @change="stepUpdateWelcomeOption({ event: $event, id: step.id })" class="klickart-select">
          <option
            value="yes-no"
            :selected="step.welcome_option === 'yes-no'">
            {{ $t('edit.canvas.first_value_welcome_select') }}
          </option>
          <option
            value="start"
            :selected="step.welcome_option === 'start'">
            {{ $t('edit.canvas.second_value_welcome_select') }}
          </option>
        </select>
      </div>

      <div class="kp-modular-row clearfix">
        <label class="kp-modular-label label__checkbox">{{ $t('edit.canvas.welcome_active') }}</label>
        <div class="kp-modular-check pull-right kp-modular-check-without-icon">
          <input
            type="checkbox"
            @change="stepUpdateWelcomeActive({ event: $event, id: step.id })"
            :checked="step.welcome_active">
            <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    step: 'stepActive',
  }),
  methods: mapActions([
    'stepUpdateWelcomeActive',
    'stepUpdateWelcomeOption',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Welcome.vue?6f2d8d28
 **/